/* eslint-disable no-console */
import zukeeper from 'zukeeper';
import {create} from 'zustand';

// import {ICompanyDetails} from '../../components/Forms/interface/formInterfaces';
import {subscriptionPlanTypes} from '../../constants/subscriptionConstants';

import {financialYear} from './../../interface/Units';

export enum countModule {
  facility = 'facility',
  internalUsers = 'internalUsers',
  externalStakeholders = 'externalStakeholders'
}

export enum accessModule {
  facility = 'facility',
  employees = 'employees',
  internalUsers = 'internalUsers',
  externalStakeholders = 'externalStakeholders',
  scope1 = 'scope1',
  scope2 = 'scope2',
  scope3 = 'scope3',
  reportStudio = 'reportStudio',
  AIDocumentManager = 'AIDocumentManager',
  processFlow = 'processFlow',
  stakeholderTracking = 'stakeholderTracking',
  Reporting_And_ESG = 'Reporting_And_ESG',
  peer_benchmarking = 'peer_benchmarking',
  gap_analytics = 'gap_analytics',
  strategy = 'strategy',
  pageAccessConfigs = 'pageAccessConfigs',
  stakeHolderEngagement = 'stakeHolderEngagement',
  mySDG = 'mySDG',
  myNetZeroTarget = 'myNetZeroTarget',
  myNetZeroSim = 'myNetZeroSim',
  exploreSol = 'exploreSol',
  myNetZeroStrat = 'myNetZeroStrat',
  reportsAccess = 'reportsAccess',
  type = 'type',
  Platform_Education = 'Platform_Education'
}

interface ISubscription {
  planType: string;
  planRules: any;
  startDate: string;
  endDate: string;
}

interface companyStore {
  companyId: string;
  // companyDetails: ICompanyDetails;
  companyDetails: any;
  facilityDetails: any;
  ownership: any;
  holding: any;
  machine: any;
  preUnits: {
    area: string;
    volume: {liquid: string; gas: string};
    weight: string;
    distance: string;
    currency: string;
    electricity: string;
    financialYear: financialYear;
    energyInput: string;
    emissionsNZM: string;
    consumptionWeightNZM: string;
    consumptionVolumeNZM: string;
    energyOutputNZM: string;
  };
  currentCount: {
    facility: number;
    internalUsers: number;
    externalStakeholders: number;
  };
  subscription: ISubscription;
  onBoarding: boolean;
  triggerFacilityRefresh: boolean;
  setCompanyId: (companyId: string) => void;
  setCompanyDetails: (companyDetails: any) => void;
  setCurrentCount: (type: countModule, count: number) => void;
  setSubscription: (subscription: ISubscription) => void;
  setFacilityDetails: (facilityDetails: any) => void;
  setPreUnits: (preUnits: any) => void;
  setOnBoarding: (status: boolean) => void;
  setTriggerFacilityRefresh: (triggerFacilityRefresh: boolean) => void;
}

const useCompanyStore = create<companyStore>(
  zukeeper((set: any) => ({
    companyId: '',
    companyDetails: {},
    facilityDetails: {},
    ownership: null,
    holding: [],
    preUnits: {},
    currentCount: {
      facility: 0,
      internalUsers: 0,
      externalStakeholders: 0
    },
    subscription: {
      planType: subscriptionPlanTypes.FREE,
      planRules: {},
      startDate: '',
      endDate: ''
    },
    onBoarding: true,
    triggerFacilityRefresh: false,
    setCompanyId: (companyId: string) => {
      set(() => ({companyId}));
    },
    setCurrentCount: (type: countModule, count: number) => {
      set((state: any) => ({
        currentCount: {
          ...state.currentCount,
          [type]: count
        }
      }));
    },
    setCompanyDetails: (companyDetails: any) => {
      set(() => ({companyDetails}));
    },
    setSubscription: (subscription: ISubscription | null) => {
      set(() => ({subscription}));
    },
    setFacilityDetails: (facilityDetails: any) => {
      set(() => ({facilityDetails}));
    },
    setPreUnits: (preUnits: any) => {
      set(() => ({preUnits}));
    },
    setOnBoarding: (onBoarding: boolean) => {
      set(() => ({onBoarding}));
    },
    setTriggerFacilityRefresh: (value: boolean) => {
      set(() => ({triggerFacilityRefresh: value}));
    }
  }))
);

(window as any).store = useCompanyStore;

export default useCompanyStore;
